import { BrowserRouter as Router, Routes, Route, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import Payment from "./pages/payment/Payment";
import Dashboard from "./pages/customer/NewDashboard";
import Login from "./pages/auth/Login";
import Protected from "./components/Protected";
import Register from "./pages/customer/Register";
import RegisterTest from "./pages/customer/RegisterText";
import ForgetPassword from "./pages/auth/ForgetPassword";
import ResetPassword from "./pages/auth/ResetPassword";
import SingleMemberLLC from "./pages/legalTools/SingleMemberLLC";
import SingleMemberLLCForm from "./pages/legalTools/SingleMemberLLCForm";
import NewSingleMemberLLCForm from "./pages/legalTools/NewSingleMemberLLCForm";
import MultiMemberLLC from "./pages/legalTools/MultiMemberLLC";
import NDABuilder from "./pages/legalTools/NDABuilder";
import CustomerAgreements from "./pages/agreements/CustomerAgreements";
import PaymentHistory from "./pages/payment/PaymentHistory1";
import Profile from "./pages/customer/Profile";
import { ErrorBoundary } from "react-error-boundary";
import Error from "./Error";
import ResetPasswordConfirmation from "./pages/auth/ResetPasswordConfirmation";
import ProSlayLanding from "./pages/landing/LandingPage";
import PaymentSuccess from "./components/CheckoutForm/PaymentSuccess";
import Services from "./pages/landing/ServicePage";
import About from "./pages/landing/AboutPage";
import HowItWorksPage from "./pages/landing/howItWorksPage";
import TermsConditionsPage from "./pages/landing/Terms&ConditionsPage";
import RequestCallPage from "./pages/landing/RequestCallPage";
import LegalServicesMenuPage from "./pages/landing/LegalServicesMenuPage";
import ScrollToTop from "./pages/common/ScrollTop";
import FounderPage from "./pages/landing/FounderPage";
import AIPage from "./pages/landing/AIPage";
import SignedAgreement from "./pages/legalTools/SignedAgreement";
import AccountConfiguration from "./pages/customer/AccountConfiguration";

// AuthChecker component
function AuthChecker() {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("accessToken");

    // Define protected routes
    const protectedRoutes = [
      "/dashboard",
      "/legaltools/singlememberllc",
      "/legaltools/singlememberllcform",
      "/legaltools/multimemberllc",
      "/legaltools/ndabuilder",
      "/paymenthistory",
      "/agreement",
      "/profile",
      "/signed-agreements"
    ];

    // Check if current route is protected
    const isProtectedRoute = protectedRoutes.some((route) =>
      window.location.pathname.startsWith(route)
    );

    if (isProtectedRoute) {
      if (!token) {
        // token hi nahi hai → redirect to /
        navigate("/");
        return;
      }

      try {
        const tokenPayload = JSON.parse(atob(token.split(".")[1]));
        const expiry = tokenPayload.exp * 1000;

        if (Date.now() >= expiry) {
          // Token expire ho gaya → clear & redirect
          localStorage.removeItem("accessToken");
          navigate("/");
        }
      } catch (e) {
        // token galat hai → clear & redirect
        localStorage.removeItem("accessToken");
        navigate("/");
      }
    }
    // Agar public page hai to kuch mat kar
  }, [navigate]);

  return null; // kuch render nahi karta, sirf check karta hai
}


function App() {
  return (
    <ErrorBoundary FallbackComponent={Error}>
      <>
        <Router>
          <ScrollToTop />
          <AuthChecker />
          <Routes>
            <Route exact path="/" element={<ProSlayLanding />} />
            <Route exact path="/services" element={<Services />} />
            <Route exact path="/about" element={<About />} />
            <Route exact path="/howItWorks" element={<HowItWorksPage />} />
            <Route exact path="/login" element={<Login />} />
            <Route exact path="/register" element={<RegisterTest />} />
            <Route exact path="/forgetpassword" element={<ForgetPassword />} />
            <Route exact path="/requestcall" element={<RequestCallPage />} />
            <Route exact path="/resetpasswordconfirmation" element={<ResetPasswordConfirmation />} />
            <Route exact path="/payment-success" element={<PaymentSuccess />} />
            <Route exact path="/terms-conditions" element={<TermsConditionsPage />} />
            <Route exact path="/resetpassword/:customerId" element={<ResetPassword />} />
            <Route exact path="/dashboard" element={<Protected Component={Dashboard} navigation={"dashboard"} />} />
            <Route exact path="/legaltools/singlememberllc" element={<Protected Component={SingleMemberLLC} navigation={"singlememberllc"} />} />
            <Route exact path="/legaltools/singlememberllcform/:customerServiceId" element={<Protected Component={NewSingleMemberLLCForm} navigation={"singlememberllc"} />} />
            <Route exact path="/legaltools/multimemberllc" element={<Protected Component={MultiMemberLLC} navigation={"multimemberllc"} />} />
            <Route exact path="/legaltools/ndabuilder" element={<Protected Component={NDABuilder} navigation={"ndabuilder"} />} />
            <Route exact path="/paymenthistory" element={<Protected Component={PaymentHistory} navigation={"paymenthistory"} />} />
            <Route exact path="/agreement" element={<Protected Component={CustomerAgreements} navigation={"agreement"} />} />
            <Route exact path="/profile" element={<Protected Component={Profile} navigation={"profile"} />} />
            <Route exact path="/account-configuration" element={<Protected Component={AccountConfiguration} navigation={"account-configuration"} />} />
            <Route exact path="/payment/:userData" element={<Payment />} />
            <Route exact path="/legalservices" element={<LegalServicesMenuPage />} />
            <Route exact path="/founder" element={<FounderPage />} />
            <Route exact path="/ai" element={<AIPage />} />
            <Route exact path="/signed-agreements" element={<Protected Component={SignedAgreement} navigation={"signed-agreements"} />} />

            {/* <Route path="*" element={<Login />} /> */}
          </Routes>
        </Router>
      </>
    </ErrorBoundary>
  );
}

export default App;
